<template>
    <button
        v-if="count"
        class="CartButton relative cursor-pointer flex w-full h-full transition-all duration-500 border-l border-grey-shadow"
        :class="activeDesktop && 'active'"
        aria-label="Open cart drawer"
        :aria-expanded="activeDesktop"
        @click="toggle"
    >
        <div class="w-full text-white px-4 py-3 flex items-center justify-end lg:justify-start">
            <CartIcon
                :count="count"
                :variant="activeDesktop ? 'on-blue' : 'on-yellow'"
                class="mt-3 mr-3 flex-shrink-0"
            />
        </div>
    </button>
</template>

<script>
import CartIcon from '@/../vue/cart/CartIcon.vue';
import stateMixin from '@/../vue/cart/state-mixin.js';
import * as track from '@/../vue/cart/tracking.js';

export default {
    components: {
        CartIcon
    },
    mixins: [stateMixin],
    props: {
        cartItems: {
            type: Object,
            required: true
        },
        quoteId: {
            type: String,
            required: true
        }
    },
    methods: {
        toggle() {
            track.toggleCart('cart icon', this.activeDesktop);
            this.toggleCartDesktop();
        }
    }
};
</script>

<style scoped>
.CartButton:before {
    @screen lg {
        content: '';
        @apply h-0 w-full bg-blue-500 absolute bottom-0 left-0 transition-all duration-200;
    }
}

.CartButton.active:before {
    @screen lg {
        @apply h-full;
    }
}
</style>
